<template>
  <div>
    사입 확정화면?
    <div v-if="purchase">
      {{ purchase }}
      <v-btn @click="confirm(purchase)">확정하기</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      purchase: null,
    }
  },
  methods: {
    ...mapActions('product', ['getProductsDetail', 'confirmPurchases']),
    async confirm(purchase) {
      this.purchase = await this.confirmPurchases(purchase.uuid)
      this.$router.push(`/purchases/${purchase.uuid}/complete`)
    },
  },
  async created() {
    this.purchase = await this.getProductsDetail(this.$route.params.uuid)
  },
}
</script>
